import { type FC } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Url } from '@wix/da-url';

import s from './VideoCreatorPlaceholder.scss';
import sParent from '../VideoCreatorFiles.scss';

export interface Props {}

const VideoCreatorPlaceholder: FC<Props> = () => {
  const { t } = useTranslation();
  const llamaUrl = Url.staticCDNLink('video_generator/llama_popcorn.png');

  return (
    <div className={cn(s['root'], sParent['file-item'])}>
      <div className={s['llama-part']}>
        <img
          className={s['llama-icon']}
          src={llamaUrl}
          alt={t('studio.videoCreator.results.emptyPlaceholder.altText')}
        />
        <Heading className={s['llama-text']}>
          {t('studio.videoCreator.results.emptyPlaceholder')}
        </Heading>
      </div>
    </div>
  );
};

VideoCreatorPlaceholder.displayName = 'VideoCreatorPlaceholder';
export default VideoCreatorPlaceholder;
